import { getCurrentStationId, INIT_PAGINATION } from '@spx-portal/shared-utils';
import { useRequest } from 'ahooks';
import * as React from 'react';
import { Modal, Table } from 'ssc-ui-react';
import { PaginationProps } from 'ssc-ui-react/typings/components/pagination/types';
import { ColumnType } from 'ssc-ui-react/typings/components/table/types';

import { $gt } from '@/common/appCtx';

import * as API from '../../api';
import { formatDate } from '../../utils';

type TimeSlotModificationHistoryProps = {
  visible: boolean;
  onClose: () => void;
};

const TimeSlotModificationHistory: React.FC<TimeSlotModificationHistoryProps> = (props) => {
  const { visible } = props;
  const [pagination, setPagination] = React.useState<PaginationProps>(INIT_PAGINATION);
  const paginationRef = React.useRef<PaginationProps>(pagination);
  const [logList, setLogList] = React.useState<any[]>([]);

  const { loading, run: fetchData } = useRequest(API.getLogList, {
    manual: true,
    onSuccess: (data) => {
      setPagination({
        ...pagination,
        total: data?.data?.total ?? 0,
      });
      setLogList(data?.data?.list ?? []);
      paginationRef.current = {
        ...pagination,
        total: data?.data?.total ?? 0,
      };
    },
  });

  React.useEffect(() => {
    if (visible) {
      fetchData({
        pageno: paginationRef.current.current || INIT_PAGINATION.current,
        count: paginationRef.current.pageSize || INIT_PAGINATION.pageSize,
        station_id: getCurrentStationId(),
      });
    } else {
      setPagination(INIT_PAGINATION);
      setLogList([]);
    }
  }, [fetchData, visible]);

  const columns = React.useMemo(() => {
    return [
      {
        title: $gt('Shift ID'),
        dataIndex: 'slot_id',
        key: 'slot_id',
        width: 120,
        lineClamp: 1,
        ellipsis: true,
      },
      {
        title: $gt('Update Time'),
        dataIndex: 'operation_time',
        key: 'operation_time',
        width: 120,
        lineClamp: 1,
        ellipsis: true,
        render: (value: number) => value ? formatDate(value) : '-',
      },
      {
        title: $gt('Event'),
        dataIndex: 'operation_event',
        key: 'operation_event',
        width: 120,
        lineClamp: 1,
        ellipsis: true,
      },
      {
        title: $gt('Old Value'),
        dataIndex: 'old_value',
        key: 'old_value',
        width: 120,
        lineClamp: 1,
        ellipsis: true,
      },
      {
        title: $gt('New Value'),
        dataIndex: 'new_value',
        key: 'new_value',
        width: 120,
        lineClamp: 1,
        ellipsis: true,
      },
      {
        title: $gt('Operator'),
        dataIndex: 'operator',
        key: 'operator',
        width: 120,
        lineClamp: 1,
        ellipsis: true,
      },
    ] as ColumnType<any>[];
  }, []);

  const handleTableChange = (pagination: PaginationProps) => {
    setPagination({
      ...pagination,
    });
    paginationRef.current = {
      ...pagination,
    };
    fetchData({
      pageno: pagination.current || INIT_PAGINATION.current,
      count: pagination.pageSize || INIT_PAGINATION.pageSize,
      station_id: getCurrentStationId(),
    });
  };

  return (
    <Modal
      title={$gt('Shift Modification History')}
      visible={visible}
      width={1000}
      bodyStyle={{ minHeight: 180 }}
      footer={null}
      onCancel={props.onClose}
    >
      <Table
        loading={loading}
        columns={columns}
        dataSource={logList}
        pagination={pagination}
        rowKey={'slot_id'}
        onChange={handleTableChange}
      />
    </Modal>
  );
};

export default TimeSlotModificationHistory;
